import { isSearchExpanded, closeSearchModal } from "./search-modal";

const toggle = document.querySelector('.menu-toggle');
const closeBtn = document.querySelector('.menu-close');
const modal = document.querySelector('.menu-modal');
const overlay = document.querySelector('.menu-overlay');
const secondLevel = document.querySelector('.menu-level-2');
const menuLinks = document.querySelectorAll('.menu-link');

// OPEN MENU
if (toggle) {
  toggle.addEventListener('click', () => {
    modal.hidden = false;
    overlay.hidden = false;
    modal.classList.add('open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
    modal.querySelector('.menu-close').focus();

    if (isSearchExpanded) {
      closeSearchModal()
    }
  });
}

// CLOSE MENU
function closeMenu() {
  if (modal) {
    modal.classList.remove('open');
  }
  document.body.classList.remove('no-scroll');
  if (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
  }

  setTimeout(() => {
    if (modal) {
      modal.hidden = true;
    }
    if (overlay) {
      overlay.hidden = true;
    }
    if (secondLevel) {
      secondLevel.classList.remove('open');
      secondLevel.hidden = true;
    }

    if (toggle) {
      toggle.focus();
    }
  }, 300);
}

if (closeBtn) {
  closeBtn.addEventListener('click', closeMenu);
}
if (overlay) {
  overlay.addEventListener('click', closeMenu);
}

// OPEN SECOND LEVEL
menuLinks.forEach(btn => {
  btn.addEventListener('click', () => {
    const hasSubmenu = btn.dataset.hassubmenu === 'True';
    const targetId = btn.getAttribute('aria-controls');

    if (!hasSubmenu || !targetId) return;

    const secondLevel = document.getElementById(targetId);
    if (!secondLevel) return;

    secondLevel.hidden = false;
    secondLevel.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');

    const backBtn = secondLevel.querySelector('.menu-back');
    if (backBtn) {
      backBtn.onclick = () => {
        secondLevel.hidden = true;
        secondLevel.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      };
      backBtn.focus();
    }
  });
});